import React, { useState, useCallback } from "react";
import { useTranslation } from "ceco-polyglot";
import { Form } from "semantic-ui-react";
import CardLayout from "../../layout/CardLayout";
import { useInput } from "ceco-hooks";
import { login } from "../../api/api";
import "./Login.scss";
import CecoLogo from "../../assets/img/logo_recetario.png";
import CecotecLogo from "../../assets/img/logo-cecotec.png";

export default function Login({ router }) {
  const t = useTranslation();

  const [username, setUsername] = useInput();
  const [password, setPassword] = useInput();
  const [remember, setRemember] = useInput(false);
  const [error, setError] = useState(false);

  const submitHandler = useCallback(() => {
    login({ username, password }, remember)
      .then((result) => {
        router.push("/recipes");
      })
      .catch((err) => {
        setError(err?.detail);
      });
  }, [router, username, password, remember]);

  return (
    <CardLayout className="login-page" logout={false}>
      <img
        style={{ alignSelf: "flex-start" }}
        src={CecotecLogo}
        className="cecotec-logo"
        alt="Cecotec"
      />
    
      <Form onSubmit={submitHandler} className="login-box">
        <img
          style={{ alignSelf: "center" }}
          src={CecoLogo}
          alt="RecetarioMambo"
        />
        <Form.Input
          value={username}
          onChange={setUsername}
          className="username"
          label={t("field.username")}
        />
        <Form.Input
          value={password}
          onChange={setPassword}
          type="password"
          className="password"
          label={t("field.password")}
        />
        <Form.Checkbox
          checked={remember}
          onChange={setRemember}
          className="remember-me"
          label={t("field.keep_loggedin")}
        />

        {error && <div className="error">{t(error)}</div>}

        <Form.Button className="login-button" primary fluid type="submit">
          {t("action.login")}
        </Form.Button>
      </Form>
    </CardLayout>
  );
}
